import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import {
  organizationInfoRouteProps,
  OrganizationsMatchParams,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectMembersListModelsFromState,
  selectOwnersAndAdminsListModelsFromState,
} from 'src/redux/selectors/data/members.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectFetchSuccessFromState = (state: RootState): boolean =>
  state.app.businessRules.fetchSuccess
export const selectFetchFailureFromState = (state: RootState): boolean =>
  state.app.businessRules.fetchFailure

export const selectPatchingOrganizationsFromState = (
  state: RootState,
): boolean => state.app.businessRules.patchingOrganizations

export const selectPuttingOrganizationsFromState = (
  state: RootState,
): boolean => state.app.businessRules.puttingOrganizations

export const selectGettingReceiptRulesFromState = (state: RootState): boolean =>
  state.app.businessRules.gettingReceiptRules

export const selectGettingOrganizationCurrenciesFromState = (
  state: RootState,
): boolean => state.app.businessRules.gettingOrganizationCurrencies

export const selectSubmittingReceiptRules = (state: RootState): boolean =>
  state.app.businessRules.submittingReceiptRules

export const selectTopLevelReceiptRulesError = (
  state: RootState,
): string | undefined => state.app.businessRules.topLevelReceiptRulesError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.businessRules.errorDetailMap

export const selectOrganizationsIdFromState = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<OrganizationsMatchParams>(
      location.pathname,
      organizationInfoRouteProps,
    ) as match<OrganizationsMatchParams>
    return mtch.params.id
  },
)

export const selectAllPeopleMembersFromState = createSelector(
  [selectMembersListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)

export const selectAdminsAndOwnersFromState = createSelector(
  [selectOwnersAndAdminsListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)

export const selectReceiptRulesBeingEditedFromState = (
  state: RootState,
): boolean => state.app.businessRules.isReceiptRulesBeingEdited

export const selectPatchingOrganizationApproverFromState = (
  state: RootState,
): boolean => state.app.businessRules.patchingOrganizationApprover

export const selectTopLevelOrganizationApproverError = (
  state: RootState,
): string | undefined => {
  return state.app.businessRules.topLevelOrganizationApproverError
}

export const selectOutOfPocketExpensesEditing = (state: RootState): boolean => {
  return state.app.businessRules.isOutOfPocketExpensesBeingEdited
}

export const selectCardApprovalsEditing = (state: RootState): boolean => {
  return state.app.businessRules.isCardApprovalsBeingEdited
}
